export const SDD_PINCODE_STORAGE_KEY = 'uh_sdd_pincode';

// Both events need GTM tags before they reach GA4; untagged dataLayer
// pushes drop silently. Fire at most once per page view / result.
export const SDD_GTM_EVENTS = {
  SHOWN: 'sddNddBadgeShown',
  CHECK: 'sddNddPincodeCheck',
  RESULT: 'sddNddPincodeResult',
  CHANGE: 'sddNddPincodeChange',
} as const;
